import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table table-striped table-sm" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "col-3 col-xl-2 text-center" }
const _hoisted_5 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "align-middle text-center small" }
const _hoisted_8 = { class: "align-middle" }
const _hoisted_9 = { class: "d-flex align-items-center text-nowrap" }
const _hoisted_10 = { class: "ms-4 me-3" }
const _hoisted_11 = { class: "flex-fill me-1" }
const _hoisted_12 = { class: "align-middle small" }
const _hoisted_13 = { class: "align-middle" }
const _hoisted_14 = { class: "ms-4 me-1" }
const _hoisted_15 = { class: "text-center small flex-fill me-4 text-truncate" }
const _hoisted_16 = { class: "align-middle text-end" }
const _hoisted_17 = { class: "d-flex text-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("th", { class: "col-2 text-center" }, "Fecha", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("th", { class: "col-2 text-center" }, "Tipo", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("th", { class: "col-3" }, "Origen", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("th", { class: "col-2 col-xl-1 text-center" }, "Estatus", -1)),
          _createElementVNode("th", _hoisted_4, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "d-inline-flex w-75 align justify-content-center" }, "Valor", -1)),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("i", _hoisted_5))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_ctx.commissions?.length > 0)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commissions, (c) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: c._id
              }, [
                _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.formatDate(c._id)), 1),
                _createElementVNode("td", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, [
                      _createElementVNode("i", {
                        class: _normalizeClass(_ctx.typeIconClass(c.type))
                      }, null, 2)
                    ]),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.translateType(c.type)), 1)
                  ])
                ]),
                _createElementVNode("td", _hoisted_12, _toDisplayString(c.source), 1),
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("div", {
                    class: _normalizeClass('d-flex align-items-center ' + _ctx.statusColorClass(c.status))
                  }, [
                    _createElementVNode("span", _hoisted_14, [
                      _createElementVNode("i", {
                        class: _normalizeClass('fa-fw ' + _ctx.statusIconClass(c.status))
                      }, null, 2)
                    ]),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.translateStatus(c.status)), 1)
                  ], 2)
                ]),
                _createElementVNode("td", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "ms-4 me-1" }, "G$", -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass('flex-fill me-4 ' + _ctx.amountClass(c.status))
                    }, _toDisplayString(_ctx.toTwoDecimals(c.amount)), 3)
                  ])
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}